import React from 'react';
import { Typography, Box, Grid } from '@mui/material';

import { Illustration } from 'components/Illustration';
import { IPageTemplate } from './PageTemplate.model';
import { PageWrapper } from './styled/PageWrapper';
import { BackgroundWrapper } from './styled/BackgroundColumn';
import { IllustrationWrapper } from './styled/IllustrationWrapper';
import { TextWrapper } from './styled/TextWrapper';

const DesktopView = ({
  heading,
  message,
  helpText,
  textWidth,
  image,
  buttons,
  withBackgroundSection,
  imageWidth,
  imagePositionTop,
  imagePositionRight
}: IPageTemplate) => {
  const gridWithBackground = 7;
  const gridWithoutBackground = 5;

  return (
    <Box
      sx={{
        flexGrow: 1
      }}
    >
      <PageWrapper
        container
        sx={{
          height: '100%',
          justifyContent: 'center',
          flexWrap: 'wrap',
          overflow: 'hidden'
        }}
      >
        {withBackgroundSection ? (
          <>
            <BackgroundWrapper size={{ lg: 5 }} />
            <IllustrationWrapper
              imageWidth={imageWidth}
              imagePositionTop={imagePositionTop}
              imagePositionRight={imagePositionRight}
              withBackgroundSection
            >
              <Illustration component={image} />
            </IllustrationWrapper>
          </>
        ) : (
          <Grid
            size={{ lg: 7 }}
            sx={{
              paddingTop: '130px'
            }}
          >
            <Grid
              container
              sx={{
                height: '100%',
                justifyContent: 'flex-end',
                alignContent: 'center'
              }}
            >
              <Grid>
                <IllustrationWrapper
                  imageWidth={imageWidth}
                  imagePositionTop={imagePositionTop}
                  imagePositionRight={imagePositionRight}
                  withBackgroundSection={false}
                >
                  <Illustration component={image} />
                </IllustrationWrapper>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid
          size={{
            lg: withBackgroundSection
              ? gridWithBackground
              : gridWithoutBackground
          }}
          sx={{
            paddingTop: '130px'
          }}
        >
          <Grid
            container
            sx={{
              flexDirection: 'column',
              justifyContent: withBackgroundSection ? 'flex-start' : 'center',
              alignContent: withBackgroundSection ? 'center' : 'flex-start',
              height: '100%',
              padding: withBackgroundSection ? '120px 0 100px' : '0 0 175px'
            }}
          >
            <TextWrapper width={textWidth}>
              <Typography variant={withBackgroundSection ? 'h3' : 'h2'}>
                {heading}
              </Typography>
              <Typography variant="body1" component="div">
                {message}
              </Typography>
              {helpText && <Typography variant="body2">{helpText}</Typography>}
            </TextWrapper>
            {buttons && <Grid>{buttons}</Grid>}
          </Grid>
        </Grid>
      </PageWrapper>
    </Box>
  );
};

export default DesktopView;
